import axios from 'axios'
import moment from 'moment'
import Swal from 'sweetalert2'
import Vue from 'vue'
import store from '@/store'
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    themeStyle: {
      get: function () {
        return {
          '--color_headline1': this.master_theme['color1'],
          '--color_subheadline1': this.master_theme['color3'],
          '--color_icon1': this.master_theme['color1'],
          '--color_headline2': this.master_theme['color4'],
          '--color_subheadline2': this.master_theme['color5'],
          '--color_icon2': this.master_theme['color6'],
          '--color_picture': this.master_theme['color7'],
          '--coin_img': "url('/static/img/coin.svg')",
          '--coinLMG_img': 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3791_20250306092811679901.png'
        }
      },
      set: function (newValue) {
        this.master_theme = newValue
      }
    }
  },
  data: function () {
    return {
      language: 'th',
      master_theme: {
        'color1': '',
        'color2': '',
        'color3': '',
        'color4': '',
        'color5': '',
        'color6': '',
        'color7': ''
      },
      globalVar: 'global',
      DNS_IP: '',
      DNS_Link: '',
      DNS_Migrate: '',
      ADMIN_IP: '',
      WEB_BELINK: '',
      PK: '', // Primary Key
      ApplicationKey: '', // Token
      IPPotocalENV_Production: 'https://api-beloyalty-productions.betaskthai.tech/',
      IPPotocalENV_Production_Link: 'https://api-belinked.betaskthai.tech',
      IPPotocalENV_Migrate: process.env.baseAPIMigrate,
      IPPotocalENV_Developer: 'https://loyalty-prod-dev.betaskthai.tech',
      ADMIN_URL_Production: 'https://betask-loyalty-app.web.app',
      ADMIN_URL_Developer: 'http://localhost',
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: ''
      },
      member: null,
      shopId: null,
      colorSub: '',
      colorSub2: '',
      colorSub3: '',
      shopNameData: {
        // chubb: 'SD_1770104911502' // chubb development
        chubb: 'U53696ebf2bc8effeb59061ce66ade036' // chubb production

      }
    }
  },
  async mounted () {
    this.HEXTHEMELMGLog('#000000')
    // document.title = 'MemberCard'
    const queryString = decodeURIComponent(window.location.search).replace(
      '?liff.state=',
      ''
    )
    const value = new URLSearchParams(queryString.substring(6))
    let shopId2 = value.get('shopId')
    if (process.env.NODE_ENV === 'development') {
      this.DNS_IP = this.IPPotocalENV_Developer
      // this.DNS_IP = this.IPPotocalENV_Production
      // this.DNS_Link = this.IPPotocalENV_Production_Link
      // this.ADMIN_IP = this.ADMIN_URL_Developer + ':8081'
      // this.WEB_BELINK = this.IPPotocalENV_Developer + ':8081'
      Vue.prototype.$DNS_IP = this.IPPotocalENV_Production
      this.DNS_Link = this.IPPotocalENV_Production_Link
      this.DNS_Migrate = this.IPPotocalENV_Migrate
      this.ADMIN_IP = this.ADMIN_URL_Production
      this.WEB_BELINK = 'https://liff.line.me/'
    } else {
      this.DNS_IP = this.IPPotocalENV_Production
      this.DNS_Link = this.IPPotocalENV_Production_Link
      this.DNS_Migrate = this.IPPotocalENV_Migrate
      this.ADMIN_IP = this.ADMIN_URL_Production
      this.WEB_BELINK = 'https://liff.line.me/'
      Vue.prototype.$DNS_IP = this.IPPotocalENV_Production
    }
    if (process.env.NODE_ENV === 'development') {
      if (typeof this.$route.query.shopId !== 'undefined') {
        this.setShopId(this.$route.query.shopId)
        this.$session.remove('shopId')
        this.$session.start()
        this.$session.set('shopId', this.$route.query.shopId)
      }
    } else {
      if (this.$liff.isInClient()) {
        if (typeof this.$route.query.shopId !== 'undefined') {
          this.setShopId(this.$route.query.shopId)
          this.$session.remove('shopId')
          this.$session.start()
          this.$session.set('shopId', this.$route.query.shopId)
        }
      } else {
        if (shopId2) {
          this.setShopId(shopId2)
          this.$session.remove('shopId')
          this.$session.start()
          this.$session.set('shopId', shopId2)
        }
      }
    }
    const resolvedShopId = await this.GET_SHOPID()
    // Only set this.shopId if it's NOT declared as a prop (to avoid Vue prop mutation warning)
    if (!(this.$options.props && this.$options.props.shopId)) {
      this.shopId = resolvedShopId
    }
    Vue.prototype.$shopId = resolvedShopId
    await this.getLevelById()
    this.colorSub = await this.rgbaToHex()
    this.colorSub2 = await this.HEXToVBColorLMG(this.colorSub)
    this.colorSub3 = await this.HEXTHEMELMG(this.colorSub)

    // ใช้ Vue.prototype แทน Vue.config
    Vue.prototype.$colorSub = this.colorSub
    Vue.prototype.$colorSub2 = this.colorSub2
    Vue.prototype.$colorSub3 = this.colorSub3
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapActions('shopStore', ['setShopId']),
    ...mapGetters('lineStore', ['getLiffProfile']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    async getLevelById () {
      if (!this.member || !this.member.levelId) {
        this.levelById = null
        Vue.prototype.$levelById = null
        return
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )
      if (result) {
        this.levelById = result
        Vue.prototype.$levelById = result
      } else {
        this.levelById = null
        Vue.prototype.$levelById = null
      }
    },
    googleTranslateElementInit () {
      const googleTranslate = window.google.translate.TranslateElement(
        {
          pageLanguage: 'th',
          layout: window.google.translate.TranslateElement.FloatPosition.TOP_RIGHT,
          includedLanguages: 'en',
          autoDisplay: false
        },
        'google_translate_element'
      )

      googleTranslate.setOnAfterTranslate(function () {
        const translateIcon = document.querySelector('.goog-te-combo')
        if (translateIcon) {
          translateIcon.style.display = 'none'
        }
      })
    },
    async getMember () {
      await this.setMemberInfo(null)
      const result = await this.callBeTaskAPI('get', '/memberCard/line/get')
      if (result) {
        if (result.length > 0) {
          this.member = result[0]
        }
      }
    },
    async getTheme (theme) {
      this.themeStyle = theme
    },
    async getShop () {
      let shopId = this.GET_SHOPID()
      const result = await this.callBeTaskAPI('get', `/system_shop/get?RECORD_STATUS=N&shopId=${shopId}`)
      if (result) {
        if (result.length > 0) {
          this.setShopInfo(result[0])
        }
      }
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
      if (result) {
        if (result.length > 0) {
          this.setLevel(result)
        }
      }
    },
    async redeemReward (reward) {
      const result = await this.callBeTaskAPI('get', `/rewardCode/getChkDate?rewardId=${reward.rewardId}`)
      if (reward.supply === 'รับหน้าร้าน' || reward.supply === null) {
        Swal.fire({
          title: `${this.$t('message.ConfirmReward')}`,
          html: `<img src="${reward.pictureUrl}" width="120"/><br><br><b>${this.$i18n.locale === 'th' ? reward.name : reward.nameEng}</b><br>${this.$t('message.use')} <font color="red">${reward.resale && reward.resale > 0 ? reward.resale : reward.point}</font> ${this.$t('message.point')}<br>${this.$t('message.useBefor')} <font color="red">${result.endDate}`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: `${this.$t('message.confirm')}`,
          cancelButtonText: `${this.$t('message.cancle')}`
        }).then(async (confirm) => {
          if (confirm.isConfirmed) {
            const params = {
              redeemStatus: 'get',
              rewardId: reward.rewardId,
              supply: reward.supply,
              shopId: this.shopId
            }

            const swalLoading = Swal.fire({
              html: `
              <div>${this.$t('message.redeemingReward')}</div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style="width:50px;"><circle fill="#FF156D" stroke="#FF156D" stroke-width="2" r="15" cx="40" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate></circle><circle fill="#FF156D" stroke="#FF156D" stroke-width="2" r="15" cx="100" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate></circle><circle fill="#FF156D" stroke="#FF156D" stroke-width="2" r="15" cx="160" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate></circle></svg>
              `,
              allowOutsideClick: false,
              showConfirmButton: false,
              onBeforeOpen: () => {
                Swal.showLoading()
              }
            })
            const result = await this.callBeTaskAPI('post', `/rewardCode/edit`, params)
            swalLoading.close()
            if (result.status) {
              this.$loadReward = false
              if (reward.supply === 'รับหน้าร้าน' || reward.supply === null) {
                let text = ''
                if (this.$isEventShop(this.shopId)) {
                  text = `${this.$t('message.expireDate')}: <font color="red">${result.expiryDate}</font> <br><br><font color="red">*${this.$t('message.collectedStaffReward')}</font> `
                } else {
                  text = `code: <font color="red">${result.rewardCode}</font><br>${this.$t('message.expireDate')}: <font color="red">${result.expiryDate}</font> <br><br><font color="red">*${this.$t('message.collectedReward')}</font> `
                }
                Swal.fire({
                  title: `${this.$t('message.completeReward')}`,
                  html: text,
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: `${this.$t('message.Viewrewards')}`,
                  cancelButtonText: `${this.$t('message.cancle')}`
                }).then((confirm) => {
                  if (confirm.isConfirmed) {
                    this.getMemberProfile()
                    if (this.$isTargetShop()) {
                      this.$router.push('/C/NewMyReward')
                    } else {
                      this.$router.push('/NewMyReward')
                    }
                  }
                })
              }
            }
          } else {
            return false
          }
        })
      } else {
        Swal.fire({
          title: `${this.$t('message.ConfirmReward')}`,
          html: `<img src="${reward.pictureUrl}" width="120"/><br><br><b>${this.$i18n.locale === 'th' ? reward.name : reward.nameEng}</b><br>${this.$t('message.use')} <font color="red">${reward.resale && reward.resale > 0 ? reward.resale : reward.point}</font> ${this.$t('message.point')}<br>`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: `${this.$t('message.confirm')}`,
          cancelButtonText: `${this.$t('message.cancle')}`
        }).then(async (confirm) => {
          if (confirm.isConfirmed && reward.supply === 'link_code') {
            const params = {
              redeemStatus: 'use',
              rewardId: reward.rewardId,
              supply: reward.supply
            }
            const result = await this.callBeTaskAPI('post', `/rewardCode/edit`, params)
            if (result.status) {
              this.$loadReward = false
              if (reward.supply === 'link_code' && result.rewardCode.search('/') === -1) {
                Swal.fire({
                  title: `${this.$t('message.completeReward')}`,
                  html: `code: <font color="red">${result.rewardCode}</font><br>${this.$t('message.useLinkOrCode')}</font>`,
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: `${this.$t('message.Viewrewards')}`,
                  cancelButtonText: `${this.$t('message.cancle')}`
                }).then((confirm) => {
                  if (confirm.isConfirmed) {
                    this.getMemberProfile()
                    if (this.$isTargetShop()) {
                      this.$router.push('/C/card?openHistory=true')
                    } else {
                      this.$router.push('/card?openHistory=true')
                    }
                  }
                })
              } else {
                let showText = `user: <font color="blue">${result.rewardCode.split('/')[0]}</font><br>password: <font color="blue">${result.rewardCode.split('/')[1]}</font><br>สามารถนำ code หรือ link ด้านบนไปใช้เพื่อรับสิทธิพิเศษในโปรแกรมได้เลย</font>`
                if (result.rewardCode.split('/').length > 2) {
                  showText = `<font color="blue">${result.rewardCode}</font><br>สามารถนำ code หรือ link ด้านบนไปใช้เพื่อรับสิทธิพิเศษในโปรแกรมได้เลย</font>`
                }
                Swal.fire({
                  title: `แลกของรางวัลเรียบร้อย`,
                  html: showText,
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: `${this.$t('message.Viewrewards')}`,
                  cancelButtonText: `${this.$t('message.cancle')}`
                }).then((confirm) => {
                  if (confirm.isConfirmed) {
                    this.getMemberProfile()
                    if (this.$isTargetShop()) {
                      this.$router.push('/C/card?openHistory=true')
                    } else {
                      this.$router.push('/card?openHistory=true')
                    }
                  }
                })
              }
            }
          } else {
            return false
          }
        })
      }
    },
    async getProfileAccess (token) {
      let result = null
      await axios({
        method: 'get',
        headers: {
          accessToken: token
        },
        url: this.DNS_IP + '/line/getProfileByAccess'
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.error(error)
        result = null
      })
      return result
    },
    async callBeTaskAPI (method, url, params, profile) {
      this.profile = this.getLiffProfile()
      if (!this.profile) {
        this.profile = profile
      }
      if (typeof this.$session.getAll().shopId === 'undefined') {
        if (typeof this.$route.query.shopId === 'undefined') {
          // no-op
        } else {
          this.$session.clear()
          this.$session.start()
          this.$session.set('shopId', this.$route.query.shopId)
        }
      }
      let result = null
      await axios({
        method: method,
        headers: {
          shopId: this.$session.getAll().shopId || '',
          lineUserId: (this.profile.userId && typeof this.profile.userId === 'string') ? this.profile.userId.replace(/[^\x00-\x7F]/g, '') : '',
          lineId: (this.profile.userId && typeof this.profile.userId === 'string') ? this.profile.userId.replace(/[^\x00-\x7F]/g, '') : '',
          memberId: (this.profile.memberId && typeof this.profile.memberId === 'string') ? this.profile.memberId.replace(/[^\x00-\x7F]/g, '') : ''
        },
        url: this.DNS_IP + url,
        data: params
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.error(error)
        result = null
      })
      return result
    },
    HEXToVBColor (a) {
      let rr = parseInt(a.substr(1, 2), 16)
      let gg = parseInt(a.substr(3, 2), 16)
      let bb = parseInt(a.substr(5, 2), 16)

      if (rr * 0.299 + gg * 0.587 + bb * 0.114 > 186) {
        let black = '#000'
        return black
      } else {
        let white = '#ffffff'
        return white
      }
    },
    HEXToVBColorLMG (hex) {
      if (this.$isTargetShop()) {
        if (hex === '#E0E0E0' || hex === '#E6A405' || hex.startsWith('#FFA300') || hex.startsWith('#B3B3B3')) {
          return '#000000'
        } else if (hex === '#000000' || hex === '#000') {
          return '#FFFFFF'
        } else {
          return this.HEXToVBColor(hex)
        }
      }

      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return '#E0E0E0'
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      if (brightness > 180) {
        return '#000000' // สีเข้ม
      } else {
        return '#FFFFFF' // สีขาว
      }
    },
    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    },

    HEXTHEMELMGLog (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    },
    hexToRgbALMG (hex) {
      var c
      c = hex.substring(1).split('')
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = '0x' + c.join('')
      return 'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')'
    },
    bgColor2LMG (rgb) {
      var c = rgb.slice(3).slice(1, -1).split(',')
      return 'rgb(' + (parseInt(c[0]) + 70) + ',' + (parseInt(c[1]) + 70) + ',' + (parseInt(c[2]) + 70) + ')'
    },
    bgColor3LMG (rgb) {
      var c = rgb.slice(3).slice(1, -1).split(',')
      return 'rgb(' + (parseInt(c[0]) + 70) + ',' + (parseInt(c[1]) + 70) + ',' + (parseInt(c[2]) + 70) + ', 0.3)'
    },
    bgColorActivityCardLMG (rgb) {
      var c = rgb.slice(3).slice(1, -1).split(',')
      return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ', 0.7)'
    },
    async rgbaToHex () {
      const color = await this.checktheme()
      const match = color.match(/\d+(\.\d+)?/g) // ดึงตัวเลขทั้งหมดออกจากสตริง
      if (!match || match.length < 3) {
        return '#000000'
      } // ถ้ารูปแบบไม่ถูกต้อง คืนค่าเป็นสีดำ

      const [r, g, b, a] = match.map(Number) // แปลงค่าเป็นตัวเลข
      const toHex = (value) => value.toString(16).padStart(2, '0')
      const red = toHex(r)
      const green = toHex(g)
      const blue = toHex(b)
      // ถ้ามี alpha ให้ต่อท้าย ถ้าไม่มีให้คืนค่า 6 หลัก
      if (typeof a === 'number' && !isNaN(a)) {
        const alpha = toHex(Math.round(a * 255))
        return `#${red}${green}${blue}${alpha}`
      } else {
        return `#${red}${green}${blue}`
      }
    },
    async checktheme () {
      const Hex = this.$isTargetShop() ? this.$bgColor : this.$bgColor2
      return Hex
    },
    cardColor () {
      const color = this.$isTargetShop() ? this.$CUSTOMMainTextColor : this.$colorSub
      return color
    },
    checkpushCustom () {
      const color = this.$isTargetShop()
      return color
    },
    formatNumber (value) {
      if (value && value !== 0) {
        return Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return 0
      }
    },
    setMemberInfo (payload) {
      store.commit('memberStore/SET_MEMBERINFO', payload)
    },
    getMemberInfo () {
      return store.getters['memberStore/GET_MEMBERINFO']
    },
    setShopInfo (payload) {
      store.commit('shopStore/SET_SHOPINFO', payload)
    },
    getShopInfo () {
      return store.getters['shopStore/GET_SHOPINFO']
    },
    setLevel (payload) {
      store.commit('shopStore/SET_LEVEL', payload)
    },
    async getLevel () {
      return store.getters['shopStore/GET_LEVEL']
    },
    setLiffId (payload) {
      this.liffId = payload
      store.commit('lineStore/SET_LIFFID', payload)
    },
    async getLiffId () {
      return store.getters['lineStore/GET_LIFFID']
    },
    format_date (value) {
      if (value) {
        return moment.utc(String(value)).format('DD/MM/YYYY HH:mm')
      }
    },
    format_date_thai (value) {
      if (value) {
        return moment(String(value)).lang('th').format('ll')
      }
    },
    // YYYY-MM-DD
    momenDate_1 (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    momenDate_2 (value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
      }
    },
    momenDate_3 (value) {
      if (value) {
        return moment(String(value)).format('DD MMM YYYY')
      }
    },
    momenDate_4 (value) {
      if (value) {
        return moment(String(value)).format('MMM YYYY')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/globalMixin.js